// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4t3i1osq{height:100%}
._c71lviql{max-height:2rem}
._c71lxy5q{max-height:var(--ds-space-400,2pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/FlexibleCard/components/blocks/footer-block/resolved/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,eAAe;AAC1B,WAAW,kCAAkC","sourcesContent":["._4t3i1osq{height:100%}\n._c71lviql{max-height:2rem}\n._c71lxy5q{max-height:var(--ds-space-400,2pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
